import {
  buildApplyStageRoutePath,
  useDefineProviderRoute,
} from "@versatile-credit-apply/composition"
import { type RouteRecordRaw } from "vue-router"
import {
  ScreenId,
  type StaticProviderKey,
} from "@versatile-credit-apply/omni-apply-client"

const providerKey: StaticProviderKey = "genesis_standard"
const { defineRoute } = useDefineProviderRoute(providerKey)

export const routes: RouteRecordRaw[] = [
  defineRoute({
    path: "/apply/:applyStage/responses/approved",
    inherit: true,
    component: () =>
      import("@/providers/genesis_standard/views/GenesisApprovedView.vue"),
  }),

  defineRoute({
    path: "/apply/:applyStage/responses/prequalified",
    inherit: true,
    component: () =>
      import("@/providers/genesis_standard/views/GenesisPrequalifiedView.vue"),
    meta: {
      screenId: ScreenId.OFFER_PRESENTATION_PREQUAL,
    },
  }),

  defineRoute({
    path: "/apply/prequalify/terms",
    inherit: true,
    redirect: (to) =>
      buildApplyStageRoutePath(to.params.providerKey as string, "/submit", {
        params: to.params,
      }),
  }),

  defineRoute({
    path: "/apply/offer/terms",
    inherit: true,
    component: () =>
      import("@/providers/genesis_standard/views/GenesisOfferTerms.vue"),
  }),

  defineRoute({
    path: "/apply/full/terms",
    inherit: true,
    component: () =>
      import("@/providers/genesis_standard/views/GenesisApplyTermsView.vue"),
  }),
]
